import 'css-chunk:src/feature/settings/SettingsPrinters.module.scss';export default {
  "root": "SettingsPrinters_root",
  "icon_online": "SettingsPrinters_icon_online",
  "icon_offline": "SettingsPrinters_icon_offline",
  "table_container": "SettingsPrinters_table_container"
};